import { IEnumObject } from "@/shared/constants/enumlist";

export enum ColaboradorEnum {
  indefinido = 0,
  assessor = 1,
  cedido = 2,
  comissionado = 3,
  terceirizado = 4,
}

export const ColaboradorList: IEnumObject[] = [
  { name: '-', value: ColaboradorEnum.indefinido },
  { name: 'Assessor', value: ColaboradorEnum.assessor },
  { name: 'Cedido', value: ColaboradorEnum.cedido },
  { name: 'Comissionado', value: ColaboradorEnum.comissionado },
  { name: 'Terceirizado', value: ColaboradorEnum.terceirizado },
];